import { render } from "./QnrReportTable.vue?vue&type=template&id=35ede190"
import script from "./QnrReportTable.vue?vue&type=script&lang=ts"
export * from "./QnrReportTable.vue?vue&type=script&lang=ts"
script.render = render

export default script